// console.log("-----> custom.js <-----");

let isScrolled = false;

$(window).scroll(function(e){
  if(window.pageYOffset <= 25 && isScrolled == false){
    isScrolled = true;
    window.scrollTo(0, 0);
  }
})

window.onload = function(){


  /*Header Change Country Flags --> Start*/
  function changeFlage(country){
    document.querySelectorAll('.mobile-hide[data-country-flag]').forEach(function(element){
      element.src = window.countryFlags[country]
    });
  }

  document.querySelectorAll('.lang-currency-groups .dropdown-item.weglot-link').forEach(function(element){
    element.addEventListener('click',function(){
      changeFlage(this.dataset.country);
    })
  })

//   changeFlage(document.querySelector(`.lang-currency-groups .dropdown-item.weglot-link.weglot-link--active`).dataset.country);
  /*Header Change Country Flags --> End*/


  /*let seemore_selector = document.querySelectorAll(".header_show_hide");
  seemore_selector.forEach(function(element){
    element.addEventListener("click",function(ele){
      this.classList.add("hidden");
      this.closest("ul.header__submenu").childNodes.forEach(function(ele){
        ele.removeAttribute('class');
      });
    });
  });*/

  /* Back to Top Button --> Start */
  document.getElementById("back-top").addEventListener("click",function(e){
    e.preventDefault();
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  });
  /* Back to Top Button --> End */

  // Cookie Functions
  window.setCookie =  function(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  window.getCookie =  function(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  // For Announcement bar

  if(window.visible_every_session == false){
    let get_announcementbar =  getCookie("announcement_bar")
    if(get_announcementbar == ""){
      setCookie("announcement_bar","open")
      document.querySelector("#shopify-section-announcement-bar").classList.add("is-opened");
      document.querySelector("#shopify-section-announcement-bar").getElementsByClassName("announcement-bar")[0].classList.remove("hidden");
    }else{

      if(get_announcementbar == 'close' ){
        document.querySelector("#shopify-section-announcement-bar").classList.add("is-closed");
        document.querySelector("#shopify-section-announcement-bar").classList.remove("is-opened");
        document.querySelector("#shopify-section-announcement-bar").getElementsByClassName("announcement-bar")[0].classList.add("hidden");
      }else{
        document.querySelector("#shopify-section-announcement-bar").classList.remove("is-closed");
        document.querySelector("#shopify-section-announcement-bar").classList.add("is-opened");
        document.querySelector("#shopify-section-announcement-bar").getElementsByClassName("announcement-bar")[0].classList.remove("hidden");
      }

    }
  }else{
    setCookie("announcement_bar","",0);
  }

  
if(document.querySelector(".announcement-close--btn")){
  document.querySelector(".announcement-close--btn").addEventListener("click",function(ele){
    ele.currentTarget.closest(".section-announcement-bar").querySelector('.js-announcement').classList.add("hidden");
    document.querySelector("#shopify-section-announcement-bar").classList.add("is-closed");
    document.querySelector("#shopify-section-announcement-bar").classList.remove("is-opened");
    if(window.visible_every_session == false){
      setCookie("announcement_bar","close");
    }
  });
}



  // For Cookie Message

  let cookieSelector = document.querySelector("#accept-cookies");
  let getcookie = getCookie("cookieMessage");
  if(cookieSelector != null){
    if(getcookie == "closed"){
      cookieSelector.classList.add("hidden");
    }else{
      cookieSelector.classList.remove("hidden");
      cookieSelector.querySelector(".accept_cookies_link").addEventListener("click",function(){
        setCookie("cookieMessage","closed",1);
        cookieSelector.classList.add("hidden");
      });
    }
  }

  // For Home Rich text Read More
  let readMoreSelector = document.querySelectorAll(".rich-text--more-link");
  readMoreSelector.forEach(function(evt){
    evt.addEventListener("click",function(){
      var prevElement = this.parentNode.previousElementSibling,
          hacClass = prevElement.classList.contains('is-open'),
          readMore = window.readMoreLess_text.read_more,
          readLess = window.readMoreLess_text.read_less;
//       console.log(prevElement,this.parentNode)
      if(hacClass == true){
        prevElement.classList.remove("is-open");
        this.innerText = readMore;
      }else{
        prevElement.classList.add("is-open");
        this.innerText = readLess;
      }
    });
  })

  // var richtext_description = document.querySelector('#richtext_description');
  // var richtext_readmore = document.querySelector('.richtext_readmore');
  // var richtext_readmore_suspension = document.querySelector('.richtext_read_more_dots');
  

  // if(richtext_description){
  //   richtext_readmore.addEventListener("click",function(event){
  //         event.preventDefault();
  //       console.log(richtext_description.style.height)
  //       if (richtext_description.style.height === ''){
  //         richtext_description.style.height = 'auto';
  //         richtext_readmore.innerHTML = "Voir moins";
  //         richtext_readmore_suspension.style.display = "none";
  //       } else if (richtext_description.style.height === 'auto'){
  //         richtext_description.style.height = '';
  //         richtext_readmore.innerHTML = "Voir plus";
  //         richtext_readmore_suspension.style.display = "contents";
  //         console.log("richtext_readmore_suspension",richtext_readmore_suspension);
  //       }
  //       else{
  //         richtext_description.style.height = '150px';
  //         richtext_readmore.innerHTML = "Voir plus";
  //         richtext_readmore_suspension.style.display = "none";
  //       }
  //   });
  // }

  var deskreadmore = document.querySelector(".readmore");
  var deskreadless = document.querySelector(".readless");
  
  if (deskreadmore) {
    deskreadmore.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      descriptionFull.style.display = 'block';
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionShort.style.display = 'none';
    });
  }
  if (deskreadless) {
    deskreadless.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      descriptionFull.style.display = 'none';
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionShort.style.display = 'block';
    });
  }

  /*-- Account Page Tabs --*/

  if(document.body.classList.contains("customers-account") || document.body.classList.contains("customers-addresses")){
    let tabs = document.querySelectorAll(".tab-trigger");
    let tabsContents = document.querySelectorAll(".tab-contents");
    const tabHandler = (tab) =>{
      console.log(tab)
      localStorage.setItem("AccountTab", tab);
      let tabId = tab;
      let tabTrigger = document.querySelector(`.tab-trigger[data-tab='${tab}']`);
      tabs.forEach((tab)=>{
        tab.parentNode.classList.remove("active");
      });
      tabsContents.forEach((tabContent)=>{
        tabContent.classList.add("hide");
      });

      tabTrigger.parentNode.classList.add("active");
      document.querySelector(`.tab-contents[data-content='${tabId}']`).classList.remove("hide");
    };
    tabs.forEach((tab)=>{
      if(tab.dataset.tab){
        tab.addEventListener("click", (event) => tabHandler(event.target.dataset.tab), true);
      }
    });
    if(localStorage.getItem("AccountTab")){
      let tabId = localStorage.getItem("AccountTab");
      tabHandler(tabId)
    }
  }

  /* product page Qty */

  window.productQtySelectorLsitener = function productQtySelectorLsitener(data){
    if(document.querySelector('[data-product-quantity]')){
      document.querySelector('[data-product-quantity]').addEventListener('change',function(){
        var productPrice = parseInt(this.dataset.productPrice) * parseInt(this.value),
            formatePrice = window.Shopify.formatMoney(productPrice,window.money_format);
        document.querySelector('button[type="submit"].product-form__submit price').innerText = formatePrice;
        document.querySelector('button[type="submit"].product-form__submit').dataset.productPrice = formatePrice;
        var stickBtn = document.querySelector('button[type="button"].sticky-info-addToCart-button')
        stickBtn ? stickBtn.dataset.quantity = this.value : false;

      })
    }
  }
  window.productQtySelectorLsitener()


  /*-- Account Page Tabs --*/


  //External Links

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].hostname !== '') {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
    }
  }

  // Grid Quantity change event
  document.querySelectorAll('[data-grid-product-quantity]').forEach(function(ele){
    ele.addEventListener('change',function(e){
      window.main = this.closest('.card-wrapper');
      console.log(this.dataset,this.dataset.ctaButtonId,this.closest('.card-wrapper'));
      var mainWrapper = this.closest('.card-wrapper'),
          buttonId = this.dataset.ctaButtonId,
          value = this.value,
          buttonSelector = mainWrapper.querySelector(buttonId);
      buttonSelector.setAttribute('data-quantity',value);
    });
  })


  if(document.querySelector('.klaviyo-bis-trigger')){
    document.querySelector('.klaviyo-bis-trigger').addEventListener('click',function(){
      var cssSelector = document.getElementById('klaviyo-popup-iframe-css'),
          cloneCssSelector = cssSelector.cloneNode(true);
//       cssSelector.remove();
      setTimeout(function(){
        var iframeSelector = document.getElementById('klaviyo-bis-iframe').contentWindow.document.body;
        iframeSelector.insertAdjacentElement('afterbegin',cloneCssSelector);
      },100)
    })
  }else{
    document.getElementById('klaviyo-popup-iframe-css').remove();
  }


//   wcreateCountDownTimer(`29 Oct 21 7:00:00 pm`,`29 Oct 21 7:30:00 pm`)

  // var mainProductImageSelector = document.querySelector("[product--main-image]"),
  //     thumbnailProductSelector = document.querySelector("[product--thumbnail-image]");

  // var flkty = new Flickity( '[product--main-image]', {
  //   cellAlign: 'left',
  //   contain: true,
  //   prevNextButtons: false,
  //   pageDots: false,
  //   fade: true,
  //   asNavFor: '[product--thumbnail-image]',
  // });
  // var flkty = new Flickity( "[product--thumbnail-image]", {
  //   cellAlign: 'left',
  //   contain: true
  // })

}




window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`[data-equal]`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}

$( document ).ready(function() {
  window.PageInits = {
    //=== Collection Page ===================================================
    collection: function(a){
      var top = 0;
      var main = $(a);
      var randomClass = ( 'eH' + Math.random() ).replace('.','');
      // console.log('A random class: ' + randomClass); // ?
      main.each( function() {

        var distanceFromTop = ($(this).parents('[data-height]')[0] != undefined) ? $(this).parents('[data-height]').offset().top : false;
        // console.log('This is ' + distanceFromTop + ' from the top.');

        if ( distanceFromTop > top ) {
          $('.' + randomClass).removeClass(randomClass);
          top = distanceFromTop;
          // console.log('"top" is ' + top + 'px away');
        }

        $(this).addClass(randomClass);

        $(this).css('min-height','auto');

        var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
          return $(this).outerHeight();
        }).get()));

        $('.' + randomClass).css('min-height',newHeight);

      }).removeClass(randomClass);

    }
  }

 // PageInits.collection('.card-wrapper .card--product');
  window.PageInits.collection('.card-information__wrapper .card-information__text');
//   window.PageInits.collection('.collection-btm-text');

  $( window ).scroll(function() {

   // PageInits.collection('.card-wrapper .card--product');
    window.PageInits.collection('.card-information__wrapper .card-information__text');
//     window.PageInits.collection('.collection-btm-text');
    window.PageInits.collection('.team-sec-wrp .multicolumn-card__info .rte');
  });
});


window.createCountDownTimer = (StartDateTime,EndDateTime) => {

  if(StartDateTime == undefined && EndDateTime == undefined){
    console.warn('Start Date and End Date Is required and Also End Date is Must be Larger Than Start Date...');
    return { isFinished:true };
  }
  var month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var customStartDate = new Date(StartDateTime),
      customEndTime = new Date(EndDateTime);

  var startSecond = customStartDate.getSeconds().toString(),
      startMinute = customStartDate.getMinutes().toString();
  if(startSecond.length == 1){startSecond = '0'+startSecond;}
  if(startMinute.length == 1){startMinute = '0'+startMinute;}

  var endSecond = customEndTime.getSeconds().toString(),
      endMinute = customEndTime.getMinutes().toString();
  if(endSecond.length == 1){endSecond = '0'+endSecond;}
  if(endMinute.length == 1){endMinute = '0'+endMinute;}

  var startDate = new Date(`${customStartDate.getDate()} ${month[customStartDate.getMonth()]} ${customStartDate.getFullYear()} ${customStartDate.getHours() +':'+ startMinute +':'+ startSecond}`),
      endTime = new Date(`${customEndTime.getDate()} ${month[customEndTime.getMonth()]} ${customEndTime.getFullYear()} ${customEndTime.getHours() +':'+ endMinute +':'+ endSecond}`);

  var currentTime = new Date().getTime();
  var distance = endTime.getTime() - currentTime
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var isFinished = false,
      timeStart = (currentTime >= startDate.getTime());

  if(currentTime > endTime){
    isFinished =  true;
  }
  var data = {days:days,hours:hours,minutes:minutes,seconds:seconds,isFinished:isFinished,timeStart:timeStart};
  return data;
}


function getBroswerDetails() { //Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
      document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
      document.querySelector("html").classList.add("mac");
  } else {
      document.querySelector("html").classList.add("windows");
  }


  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
      document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
      document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
      document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
      document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
      document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
      document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
      document.querySelector("html").classList.add("isEdgeChromium")
  } else {
      document.querySelector("html").classList.add("isBlink")
  }
}

getBroswerDetails();


//replace the links
let currentURL = window.location.href;
if (currentURL.includes('/en')) {

    document.querySelectorAll('.collection-list__item.grid__item [href],.multicolumn-list__item [href],.first_level_menu_item summary [href],.secound_level_menu_item [href]').forEach(function (element) {
        if (!element.href.includes('https://mylittleday.fr/en/')) {
            let newURL = element.href.replace('https://mylittleday.fr/', 'https://mylittleday.fr/en/');
            console.log(newURL)
            element.href = newURL;
      }
    });

}

